import { render, staticRenderFns } from "./CintillosFree.vue?vue&type=template&id=0ccf9c56&scoped=true"
import script from "./CintillosFree.vue?vue&type=script&lang=js"
export * from "./CintillosFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf9c56",
  null
  
)

export default component.exports